import { reportEvents as reportEventsApi } from './api';

// Types
import type { Event } from '@shopee-user/real-time-metrics-event';

export function createMetricsReporter() {
  // TODO @tranct batch events with debounde and report 1 time to optimize
  const reportEvents = async (events: Event[]) => {
    return reportEventsApi({ events });
  };

  return {
    reportEvents,
  };
}

export { MetricsReportContext } from './context';
export { useMetricsReport } from './hook';
